import { ArrowLeft } from 'lucide-react';

const LIBRARY_META = {
  remnant: { name: 'Remnant Library', desc: 'Stock remnants from nesting operations — available for reuse in future BOMs' },
};

export default function ComingSoonLibrary({ tabId, onBack }) {
  const meta = LIBRARY_META[tabId] || { name: tabId, desc: '' };

  return (
    <div className="h-full flex flex-col items-center justify-center bg-slate-950 text-white" data-testid={`coming-soon-${tabId}`}>
      {/* Back link */}
      <button
        onClick={onBack}
        className="absolute top-4 left-4 flex items-center gap-2 text-slate-500 hover:text-slate-300 text-xs transition-colors"
        data-testid="coming-soon-back"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Back to Product Builder
      </button>

      {/* Icon */}
      <div className="w-20 h-20 rounded-2xl border border-slate-700/50 flex items-center justify-center mb-6 opacity-30">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="4" y="8" width="32" height="24" rx="3" stroke="#94A3B8" strokeWidth="1.5" />
          <line x1="4" y1="14" x2="36" y2="14" stroke="#94A3B8" strokeWidth="1" />
          <line x1="16" y1="14" x2="16" y2="32" stroke="#94A3B8" strokeWidth="1" />
          <circle cx="10" cy="11" r="1.5" fill="#94A3B8" />
          <circle cx="14" cy="11" r="1.5" fill="#94A3B8" />
        </svg>
      </div>

      {/* Title */}
      <h2 className="text-lg font-semibold text-slate-200 mb-2">{meta.name}</h2>

      {/* Coming Soon badge */}
      <span className="text-amber-500 text-sm font-mono font-semibold tracking-wider mb-3">Coming Soon</span>

      {/* Description */}
      <p className="text-slate-500 text-xs text-center max-w-sm leading-relaxed">{meta.desc}</p>

      {/* Subtle version note */}
      <div className="mt-8 px-4 py-2 rounded border border-slate-800 text-[10px] text-slate-600 font-mono">
        Planned for upcoming release
      </div>
    </div>
  );
}
